import { createModel, RematchDispatch } from '@rematch/core';
import { PaginationType } from 'types/common.d';
import { TenantType } from 'types/entities/tenants.d';
import * as tenantsApi from 'services/tenants';
import { UserType } from 'types/user.type';
import { RootModel } from '../models';
import baseEntity from './base.entity';

export const storeName = 'tenantsEntity';

export const tenantsEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof tenantsEntity>) => ({
    async load(payload): Promise<{ content: TenantType[] } & PaginationType> {
      try {
        const res = await tenantsApi.filter(payload);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async findById(payload, state) {
      try {
        const item = state[storeName].ids[payload];
        if (item && !item.isSimplified) {
          return item;
        }
        const res = await tenantsApi.getById(payload);
        this.saves([res.data]);
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async save(payload) {
      try {
        let item;
        if (!payload.id) {
          ({ data: item } = await tenantsApi.create(payload));
        } else {
          ({ data: item } = await tenantsApi.update(payload.id, payload));
        }
        this.update(item);
      } catch (e) {
        throw new Error(e);
      }
    },
    async loadUserForAddingTenant(payload): Promise<{ content: UserType[] } & PaginationType> {
      try {
        const res = await tenantsApi.filterUrForAddingTenant(payload);
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default tenantsEntity;
